import { useEffect, useState } from "react";
import { AudioWave } from "@/components/AudioWave";

// Pre-call popup shown to the caller: username, live mic waveform, START.
export function SpeakModal({ otherName, onCancel, onStart }) {
  const [stream, setStream] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let s;
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((st) => { s = st; setStream(st); })
      .catch(() => setErr("microphone access denied"));
    return () => { try { s?.getTracks().forEach((t) => t.stop()); } catch (e) { console.debug("speakmodal: stop tracks failed", e); } };
  }, []);

  const start = () => {
    try { stream?.getTracks().forEach((t) => t.stop()); } catch (e) { console.debug("speakmodal: start stop tracks failed", e); }
    onStart();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in"
      style={{ background: "rgba(0,0,0,0.7)" }}
      onClick={onCancel}
      data-testid="speak-modal-overlay"
    >
      <div
        className="w-full max-w-md p-8"
        style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }}
        onClick={(e) => e.stopPropagation()}
        data-testid="speak-modal"
      >
        <div className="flex justify-between items-start mb-6">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>speak</span>
          <button onClick={onCancel} data-testid="speak-modal-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>
            [ close ]
          </button>
        </div>
        <h3 className="font-head text-2xl mb-6" style={{ color: "var(--text-primary)" }} data-testid="speak-modal-username">
          {otherName}
        </h3>
        <AudioWave stream={stream} testId="speak-modal-wave" />
        {err && <p className="text-xs mt-3" style={{ color: "var(--accent)" }} data-testid="speak-modal-error">{err}</p>}
        <button onClick={start} disabled={!stream} data-testid="speak-start-btn" className="btn w-full py-3 mt-6 text-sm tracking-widest">
          START
        </button>
      </div>
    </div>
  );
}
